export default "__VITE_ASSET__CqHbM7Yd__"